/**
 * @file geneDiseaseClassificationEvidenceDelete.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 23, 2024 18:58
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    GENE_DISEASE_CLASSIFICATION_EVIDENCE_DELETE_REQUEST,
    geneDiseaseClassificationEvidenceDeleteSuccess,
    geneDiseaseClassificationEvidenceDeleteFailure,
} from 'src/store/actions/geneModel/geneModelDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/geneModel/geneDiseaseClassificationEvidence/evidenceDelete';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            objId: payload.objId,
            pageMap: payload.pageMap,
            geneDiseaseClassificationEvidenceId: payload.evidenceId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (resp.payload.errorExists && stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(geneDiseaseClassificationEvidenceDeleteSuccess(resp.payload));

    } catch (error) {
        yield put(geneDiseaseClassificationEvidenceDeleteFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }


}

export default function* searchRequestMonitor() {
    yield takeLatest(GENE_DISEASE_CLASSIFICATION_EVIDENCE_DELETE_REQUEST, requestSaga);
}
